<template>
    {{componentGridGroups}}
    <div v-if="componentGridGroups.length">
        <template
            v-for="componentGridGroup in componentGridGroups"
            :key="componentGridGroup.index"
        >

            <div
                class="component-grid-items-wrapper"
                :class="`vr-row-${ componentGridGroup.vertical_ratio }`"
            >
                <template v-for="component in componentGridGroup.components" :key="component.index">
                    <template v-if="component.post_type == 'bryter-dt-chart'">
                        <ChartComponent
                            :index="component.index"
                            :chartData="component"
                            :chartClass="component.chart_class"
                        />
                    </template>
                </template>
            </div>
        </template>
    </div>
</template>
<script>
//Chart
import ChartComponent from '@vueapp/components/ChartComponent.vue'


export default {
    name: 'ComponentGridComponent',
    components: {
        ChartComponent
    },

    props: {
        componentGridGroups: {
            type: Object,
            required: true,
            default: []
        }
    },

    //copied from DataviewComponent.vue
    data() {
        return {
            // vw: false,
            count: 0,
            filters: {},
            sorting: {
                sortType: '',
                columnName: '',
                sortOrder: 'asc'
            },
            data: {},
            keyword: ''
            // sort: true
        }
    },
    emits: ['refresh'],
    computed: {
        feTheme() {
            return window.fe_theme
        },
        search() {
            return this.templateData.search || []
        },
        softFilterArgument() {
            return this.templateData.soft_filter_argument ? this.templateData.soft_filter_argument : null
        },
        vw() {
            if(document.querySelector('.single-bryter-view-wrapper')) {
                return true
            }

        },
    },
    created() {
        this.data = this.templateData
    },

    updated() {
        if(this.templateData) {
            this.data.database_columns_data = this.templateData.database_columns_data
        }
    },

    methods: {
        filtersSubmit(filters) {
            this.filters = filters //{ ...this.filters, ...filters }
            let sorting = this.sorting
            // this.refreshDataview()
            this.$emit('refresh', {filters: this.filters, sorting})
        },

        searchSubmit( keyword ) {
            this.keyword = keyword
        },

        toQueryString(obj, prefix) {
            var str = [], k, v;
            for(var p in obj) {
                if (!obj.hasOwnProperty(p)) {continue;} // skip things from the prototype
                if (~p.indexOf('[')) {
                    k = prefix ? prefix + "[" + p.substring(0, p.indexOf('[')) + "]" + p.substring(p.indexOf('[')) : p;
                    // only put whatever is before the bracket into new brackets; append the rest
                } else {
                    k = prefix ? prefix + "[" + p + "]" : p;
                }
                v = obj[p];
                str.push(typeof v == "object" ?
                    this.toQueryString(v, k) :
                    encodeURIComponent(k) + "=" + encodeURIComponent(v));
            }
            return str.join("&");
        },

        urldecode( url ) {
            return url
        },

        sortAction( evt ) {
            // this.sorting.columnName = evt.column.column_name
            // this.sorting.sortOrder = evt.column.sort.dir
            this.sorting = evt.sorting
            // this.refreshDataview()
            let filters = this.filters,
                sorting = this.sorting
            this.$emit('refresh', {filters, sorting})
        }

    }

}
</script>